import type { CSSProperties, ReactNode } from 'react'
import type { HuntType } from '@/shared/domain'

const BASE_STROKE_WIDTH = 2.45
const MIN_STROKE_PX = 0.9

type LineIcon = {
  viewBox: string
  body: ReactNode
}

const ICONS: Record<HuntType, LineIcon> = {
  migratory_bird: {
    viewBox: '9.68 35.09 74.83 74.83',
    body: (
      <>
        <path d="m29.99 54.28c-0.67-1.09-0.75-2.57-0.47-3.52-1.26-1.44-1.46-4.07 0.36-3.94-1.17-2.31-1.41-5.63-0.92-5.49 0.5 0.14 3.08 4.9 10.88 10.38 5.33 3.76 9.12 5.19 9.52 10.54 0.36 4.89 1.07 10.2 3.05 11.21" />
        <path d="m14.96 42.76c0.41 0.04 0.86 0.57 1.58 1.38 3.41 3.91 8.62 8.14 15.9 11.6 4.8 2.29 8.07 4.05 9.96 9.14 2.06 5.55 5.06 9.44 8.09 9.54 1.1 0.04 7.84-0.56 11.62-4.91 2.52-2.92 4.97-5.84 8.67-5.78 1.6 0.02 3.09 0.86 4.04 2.09 1.32 1.73 5.3 2.8 7.66 3.03 0.71 0.08 0.66 0.74 0.17 1.21-1.16 1.11-6.54 1.09-7.76 1.09-1.26 0.73-3.33 1.15-4.99 1.38-4.61 0.66-8.13 4.66-10.55 9.04-4.96 9.05-16.12 14.67-30.93 13.58" />
        <path d="m32.63 95.52c-2.99 4.7-8.49 7.95-10.88 8.13l-0.16-1.43c-2.57 1.47-5.27 1.75-5.55 1.15-0.36-0.79 1.23-2.23 1.23-2.23-2.26 0.6-4.67 0.23-4.66-0.69 0.01-1.39 4.07-3.42 5.47-4.32-2.21 0.28-4.16-0.2-4.19-1.29-0.04-1.73 5.19-2.37 9.52-4.52 3.49-1.74 4.47-4.7 9.32-6.46" />
        <path d="m31.29 84.25c-1.56-0.37-2.08-2.29-1.67-3.57-1.8-0.77-2.32-2.57-1.31-3.71-2.14-0.74-3.57-2.79-1.55-3.73-3.17-0.73-5.74-2.92-4.03-4.17-3.34-1.14-5.92-4.09-5.98-4.95l3.6 0.13c-4.12-2.01-6.77-5.47-6.72-6.54l4.51 1.34c-4-2.67-6.57-6.1-6.59-7.65l5.13 2.36c-3.99-3.46-5.73-7.66-5.47-8.69 1.72 0.51 4.38 2.56 5.8 4.26" />
        <path d="m55.31 73.37c1.72 2.01 4.01 4.29 4.02 6.84" />
        <path d="m59.18 71.86c1.26 1.16 2.6 2.59 3.56 3.85" />
        <path d="m75.43 68.32c0.12 1.12-0.41 2.13-1.29 2.82" />
        <circle cx="71.24" cy="66.57" r="1" fill="currentColor" />
      </>
    ),
  },
  deer: {
    viewBox: '-3.04 123.6 92.34 92.34',
    body: (
      <>
        <path d="m63.08 159.5c0.15 10.79-1.75 19.08-9.19 24.27-1.83 1.32-3.56 19.49-3.18 25.05 0.1 1.52 3.25 5.26 2.4 5.51-0.54 0.16-3.92 0.1-5.02 0.1-1.42 0-0.95-2.02-1.57-2.45-0.64-0.45-1.23-1.07-1.09-2.14 1.15-9.13-0.93-22.93-0.04-28.26-0.73 0.81-0.78 2.19-1.07 2.65-4.02 0.73-10.73-0.59-14.33-1.47" />
        <path d="m31.12 176.8c0.2 6.16-4.67 11.72-10.5 16.37-3.97 3.17-4.4 8.53-4.5 14.59-0.03 2.34 3.46 5.99 2.54 6.45-0.5 0.25-4.43 0.18-5.37 0.18-1.61 0-1.07-2.28-1.77-2.76-0.62-0.42-0.94-1.1-0.83-2.09 0.54-4.86 0.8-11.33 0.86-15.13 0.02-1.09 0.68-2.03 1.62-2.85 2.36-2.09 4.05-4.9 3.4-8.13-0.72-3.61-1.65-6.73-1.51-10.07 0.25-6.74 5.09-10.77 11.63-10.74 4.76 0.02 9.27 0.84 13.57 0.73 3.51-0.09 6.67-1.37 9.26-1.28 3.74 0.13 4.65-7.96 5.14-12.03-4.53 0.07-6.75-3.42-6.62-6.36 2.91-0.41 6.17 1.15 7.49 3.19" />
        <path d="m65.18 146.9c1.3-2.41 4.57-3.58 7.08-3.39 0.12 3.1-2.88 6.06-6.32 6.02-0.59 1.91 0.16 4.35 1.62 6.4 1.1 1.58-0.38 3.71-2.9 3.63-2.02-0.07-4.47-1.08-5.24-1.7" />
        <ellipse
          transform="rotate(34 58.9 150.8)"
          cx="58.9"
          cy="150.8"
          rx="1.363"
          ry="1.027"
          fill="currentColor"
        />
        <path d="m67.57 156c-0.63 0.45-1.72 0.58-2.54 0.54" />
        <path d="m17.44 166.3c-5.46 0.4-7.43 4.58-6.89 9.06 0.26 2.12 0.07 4.38-0.44 6.04 2.41 0.01 4.48-2.1 5.1-4.95" />
        <path d="m45.95 126.2c-1.72 4.31-1.86 10.72 2.61 12.76 3.26 1.49 7.88 1.67 9.41 6.36 1.86-0.44 3.85-0.53 5.56-0.15 0.95-2.97 5.28-4.08 8.95-5.89 3.92-1.95 4.23-7.59 3.12-10.82" />
        <path d="m50.34 125.1c-1.05 2.31-1.38 5.41-1.42 7.84-0.03 1.51-1.11 2.67-1.52 3.45 2.37-2.16 6.1-3.71 7.03-6.51" />
        <path d="m56.11 136.2c-0.62 1.61-0.85 3.88-0.93 5.34" />
        <path d="m64.22 136.2c0.54 1.74 0.76 3.97 0.71 5.68" />
        <path d="m70.21 125.1c0.92 2.3 1.19 5.3 1.22 7.9 0.02 1.28 1.15 2.95 1.96 4.01-2.86-2.54-6.4-4.11-7.21-6.99" />
      </>
    ),
  },
  turkey: {
    viewBox: '171.13 140.14 75.53 75.53',
    body: (
      <>
        <path d="m223.2 162.8c1.17-3.66 0.16-7.97-2.56-9.16 0.02-3.79-2.56-6.47-5.93-6.44-1.18-3.63-5.01-5.09-8.36-4.01-2.93-2.31-7.26-1.98-9.48 0.56-3.68-1.2-7.59 0.88-8.13 4.15-3.67 0.03-7.02 3.38-6.38 6.85-3.63 0.73-5.31 5.22-4 8.38-3.43 1.76-3.7 6.96-1.26 9.6-2.74 2.57-1.61 7.97 1.74 9.75-1.62 3.62 1.32 8.59 4.79 8.53 2-0.26 5.51-2 7.24-3.16" />
        <path d="m196.2 186.2c-1.55-1.9-1.91-4.61-1.74-7.12 0.66-10.67 10.22-18.17 20.39-18.16 6.05 0.01 11.31 2.5 14.72 5.72 1.01 0.95 2.22 1 2.82-0.23 1.01-2.12-0.77-6.07-2.53-9.14-2.68-4.79-0.74-9.91 4.21-9.96 2.8-0.03 5.02 1.93 5.14 4.49 2.01 1.33 3.25 3.04 3.07 4.34-2.01-0.9-4.71-1.14-5.31-0.7-1.01 2.97 4.4 9.3 4.77 13.72 0.15 1.94-0.62 3.38-1.91 4.19 0.74 1.56 1.08 3.46 1.08 5.6 0 11.4-9.75 18.07-21.35 17.98-4.64-0.04-7.12 1.5-9.4 3.25-0.81 0.63-1.25 0.04-1.16-1.24 0.12-1.65 0.22-3.34 0.9-4.4" />
        <path d="m225.4 182.1c-1.1 4.63-8.15 9.1-15.25 12.12-7.25 3.08-12.73 6.65-16.17 8.54-1.21 0.65-2.09 0.38-2.04-1.11 0.07-2.25 1.8-5.09 3.23-6.15-1.25 1.13-3.68 2.14-3.77 0.6-0.22-5.18 9.33-18.84 23.25-20.31" />
        <path d="m209.3 200.8c-0.53 3.09-0.79 6.27-1.11 8.3-0.16 1.04-0.69 1.84-1.66 2.35-1.41 0.72-2.47 1.47-2.57 1.63l3.65-1.57c1.42 1.62 3.63 2.55 4.28 2.66l-2.78-3.32c3.04 0.25 5.94 1.41 6.51 1.76" />
        <path d="m218.8 197.3c-0.87 0.94-0.76 2.42-0.14 3.78 1.31 2.86 2.18 6.07 3.03 8.16 0.36 0.92 0.72 1.58 1.77 1.79 2.9 0.4 6.13 0.91 6.55 1.53l-6.31-1.45c1.57 1.67 2.87 2.64 3.06 2.72l-4.06-2.6-3.81 1.54 3.46-2.93" />
        <polyline points="196.9 143.7 202.2 158.8" />
        <path d="m188.3 147.9 9.26 13.38" />
        <path d="m181.9 154.7 12.31 10.2" />
        <path d="m177.9 163 13.26 6.52" />
        <path d="m176.6 172.3 12.87 2.63" />
        <path d="m178.5 182.4 10.76-1.32" />
        <path d="m206.5 143.3 0.59 14.11" />
        <path d="m214.6 147.2-2.28 9.42" />
        <circle cx="235.2" cy="151.1" r="1" fill="currentColor" />
      </>
    ),
  },
  gator: {
    viewBox: '165.74 44.45 86.38 86.38',
    body: (
      <>
        <path d="m222.9 82.35c0.42 1.66 3.29 2.96 5.98 2.96 2.24 0 4.53-0.93 6.33-1.85 4.62-2.37 14.27-0.61 14.34-6.04" />
        <path d="m230.7 77.28c1.33-0.31 2.42 0.34 3.88 0.94 1.43 0.59 3.04 0.63 4.62 0.04 1.04-0.38 2.19-0.34 3.18 0.06 0.67 0.26 1.4 0.2 2.12-0.08 1.67-0.63 4.08-0.55 5.26-1.65 2.01-1.88 0.19-4.74-2.36-4.74-1.34 0-2.06 1.33-3.67 1.28-3.27-0.1-6.87-0.75-8.74-2.48-1.12-1.05-2.9-1.04-4.22-0.19-0.56 0.36-2.01-0.35-3.47-0.35-1.8 0-3.52 1.7-4.91 1.62-1.27-0.07-1.99-1.65-3.13-1.71-0.91-0.05-1.7 0.8-2.67 0.62-1.17-0.22-1.81-1.73-3.17-1.83-1.05-0.08-1.85 0.84-2.89 0.67-1.06-0.18-1.61-1.54-2.85-1.63-1.15-0.09-1.86 0.95-3.01 0.83-1.14-0.12-1.67-1.43-2.91-1.43-1.11 0-1.61 1.06-2.86 1.06-1.18 0-1.75-1.1-2.84-1.05-1.24 0.06-1.75 1.29-3.08 1.33-0.94 0.03-1.49-0.87-2.66-0.71-1.23 0.17-1.68 1.43-2.92 1.6-0.8 0.11-1.48-0.54-2.45-0.26-0.93 0.26-1.22 1.34-2.19 1.61-0.76 0.21-1.59-0.33-2.58 0.11-0.82 0.36-0.86 1.34-1.74 1.7-0.68 0.27-1.56 0-2.34 0.56-0.69 0.49-0.64 1.46-1.45 1.9-0.61 0.33-1.5 0.33-2.2 1-0.61 0.59-0.43 1.58-1.07 2.18-0.48 0.43-1.29 0.49-1.77 1.2-0.43 0.65-0.05 1.51-0.45 2.17-0.26 0.45-1 0.61-1.3 1.37-0.33 0.83 0.21 1.81-0.14 2.63-0.23 0.54-0.47 0.95-0.46 1.62-0.57 14.05 12.86 16.98 28.82 18.54 6.29 0.61 10.35 1.73 12.44 2.21 0.93 0.21 0.27-3.98-11.57-6.22-11.96-2.26-20.86-5.53-21.06-11.49-0.11-3.17 2.57-4.9 5.67-4.85 1.63 0.03 4.26 0.79 4.26 2.06 0 1.59-1.77 3.18-1.55 4.73 0.17 1.26 2.52 1.44 4.25 2.25 2.03 0.97 3.62 2.97 4.31 2.65 0.96-0.45-0.29-2.86-0.29-2.86 1.97 0.65 3.61 2.87 4.01 2.43 0.69-0.82-1.72-3.26-2.95-3.71 2.27 0.28 4.8 2.46 4.85 1.71 0.12-2.4-4.28-4.12-6.77-4.02 1.33-1.25 4.29-3.56 4.25-7.11-0.03-4.1-4.17-6.44-7.56-6.47" />
        <path d="m195 88.21c4.9 1.37 11.5 1.54 15.83 0.42" />
        <path d="m226.5 84.98c-2.64 1.67-8.07 2.58-7.97 3.59 0.04 0.47 2.51 2.44 3.99 3.67 4.26 0.71 6.74 3.04 6.75 4.35 0.01 0.55-3.76-1.64-4.72-1.68 1.75 1.3 3.13 3.73 2.78 3.91-0.42 0.21-3.36-2.46-4.1-2.61 0.75 1.56 1.3 3.46 0.87 3.47-0.64 0.01-2.41-3.19-3.02-3.19-0.23 1.22-0.25 2.86-0.19 2.8-0.98-0.17-1.62-2.1-2.75-3.35-1.75-1.92-7.12-2.25-7.38-6.73-0.18-3.6 3.17-6.54 3.34-7.25" />
        <circle cx="232.8" cy="72.91" r="1.04" fill="currentColor" />
      </>
    ),
  },
  hog: {
    viewBox: '86.99 44.46 74.41 74.41',
    body: (
      <>
        <path d="m97.99 69.94c-4.7-0.39-7 3.24-6.93 6.54-2.11 0.89-2.31 3.25-2.02 5.17 2.04-0.79 2.57-2.83 2.12-5.01" />
        <path d="m139.5 61.61c-3-1.78-7.38-2.78-11.35-2.81-6.41-0.05-12.04 2.69-16.11 4.78-2.12 1.09-4.66 1.61-6.26 1.87-4.97 0.86-10.75 5.49-10.75 13.69 0 2.57 0.29 4.95 0.54 6.8 0.31 2.41-1.24 4.62-3.11 5.5-0.67 0.31-0.97 2.26-1.61 4.73-0.62 2.4-2.35 5.39-2.36 6.25-0.01 0.89 1.21 1.17 1.24 1.75 0.05 1.26 0.8 2.08 1.83 2.08h4.22c0.72 0 0.84-0.62 0.53-1.28-0.52-1.13-2.11-2.48-2.01-3.53 0.16-2.05 1.86-5.69 5.24-7.06 5.42-2.2 9.65-5.97 10.31-11.5 0.32 1.38-0.16 2.94-0.89 4.29 4.45 1.58 9.78 2.48 14.09 1.93" />
        <path d="m124.3 84.81c-1.01 1.79-1.25 4.44-1.29 7.32-0.06 3.94-0.8 7.51-1.83 9.86-0.47 1.11 0.69 1.48 0.8 1.91 0.22 1.29 0.69 2.27 1.78 2.27h4.34c0.71 0 0.8-0.62 0.38-1.36-0.68-1.24-2.08-2.54-1.96-3.8 0.34-3.65 2.94-9.25 7.01-11.91 2.71-1.81 4.17-4.54 4.16-7.21 0.17 3.03 3.77 4.44 6.9 3.54 1.12-0.32 2.2-0.27 3.34 0.06 2.4 0.72 4.89 0.14 6.04-1.47" />
        <path d="m135.7 88.08c0.23 4.51 1.72 11.25 4.41 13.91 1.63 1.61 3.23 3.68 1.79 3.68h-4.43c-1.18 0-1.4-2.3-2.77-2.31-0.47-3.64-2.75-8.01-4.65-10.14" />
        <path d="m106.3 91.36c-1.16 3.4-0.22 9.14 2.39 11.76 1.58 1.58 3.01 3.01 1.48 3.07h-4.19c-1.37 0-1.38-2.24-2.89-2.5-0.1-3.13-1.94-7.13-3.43-8.97" />
        <path d="m146.2 65.33c0.56-2.02 0.23-4.56-0.35-5.39l-0.8 1.69c-0.88-2.5-3.72-4.66-4.49-4.55-0.62 2.6-2.07 7.77-0.39 8.89" />
        <path d="m146.2 65.35c1.97 1.12 3.28 3.37 4.05 5.94 0.85 2.92 4.43 6.3 6.48 7.26 0.98 0.45 3.02-1.01 3.16-0.04 0.2 1.7-2.05 6.8-4.62 6.1-1.69-0.46-3.51-1.2-3.51-1.2 0.18-2.07-0.06-5.1-0.54-5.1-0.77 0.06-1.94 2.76-2.1 3.21-0.73-0.61-1.66-0.98-1.87-0.8 0.42 1.6 2.78 2.64 4.51 2.69" />
        <ellipse
          transform="rotate(32 146.2 71.94)"
          cx="146.2"
          cy="71.94"
          rx="1.684"
          ry="1.041"
          fill="currentColor"
        />
      </>
    ),
  },
  upland: {
    viewBox: '76.17 135.19 89.88 89.88',
    body: (
      <>
        <path d="m160.6 150.2c-0.52-1.64-2.28-2.64-4.29-2.58-3.88 0.12-6.83 3.04-6.85 7.9-0.02 5.24-2.33 8.59-6.99 9.5-9.57 1.89-14.82 7.92-19.36 11.74-5.82 4.93-42.42 16.86-45.44 22.71 11.79-4.97 25.81-9.56 37.31-11.29-0.32 0.89-0.95 2.07-0.19 2.17 2.21 0.27 5.33-0.23 7.08-0.69" />
        <path d="m122.8 186.8c-1.33 2.16-3.04 6.44-2.36 7 0.99 0.81 5.73-0.7 7.89-1.31 10.19-3.28 17.59-12.61 17.62-17.7" />
        <path d="m129.5 193.1c0.3 2.01-0.48 4.47 0.37 5.64 0.33 0.46 1.1 0.3 1.61-0.21 1.99-2.02 4.75-4.53 7.37-5.17 10.02-2.99 16.36-11.07 17.37-21.72 0.5-5.17 0.49-9.74 0.59-13.1 0.06-1.62 0.62-2.84 1.92-3.44 1.64-0.76 2.5-2.79 2.07-4.66" />
        <path d="m160.2 150.6c2.34 0.29 4.38 1.42 4.35 2.26-1.64 0.03-3.49 0.51-4.69 1.1" />
        <circle cx="156.8" cy="150.8" r="1" fill="currentColor" />
        <path d="m149.1 159.2c1.69 1.51 4.37 2.22 6.81 2.19" />
        <path d="m147.4 162.8c1.93 2.5 5.37 3.79 8.69 3.56" />
        <path d="m130.2 198.9c-0.36 3.24-0.67 6.81-0.83 8.6-0.1 1.09-0.67 1.81-1.55 2.2-1.17 0.52-2.28 0.98-2.45 1.14l3.24-1.19c1.17 1.53 2.94 2.73 3.6 2.99l-1.97-3.4c2.57 0.52 5.03 1.82 5.66 2.29" />
        <path d="m139.6 193.5c-1.15 2.45-3.22 4.85-3.17 6.12 0.07 1.95 2.6 7.43 4.19 8.28 3.35 0.22 6.56 0.91 6.92 1.54l-6.68-1.15c2.22 1.44 3.82 2.87 3.94 3.2l-4.67-3.07-2.8 0.92" />
      </>
    ),
  },
}

function strokeWidthFor(viewBox: string, size: number): number {
  const side = Number(viewBox.split(' ')[2])
  return Math.max(BASE_STROKE_WIDTH, (MIN_STROKE_PX * side) / size)
}

export type SpeciesIconProps = {
  type: HuntType
  className?: string
  size?: number
  style?: CSSProperties
}

export function SpeciesIcon({ type, className, size = 16, style }: SpeciesIconProps) {
  const icon = ICONS[type]
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={icon.viewBox}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidthFor(icon.viewBox, size)}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
      style={style}
    >
      {icon.body}
    </svg>
  )
}
